import { useEffect, useState } from 'react';

import { ISponsors } from '../blocks/BasstrakkTable/types';
import { IBasstrakkAngler } from '../types';
import * as api from '../util/api';
import { refreshRate, sponsorRows } from '../util/util';

const ANGLER_FETCH_RATE = refreshRate([5000, 5000]);
const leaderboardApi = '/data/basstrakk-leaderboard';

const useTournamentAnglers = (tid: number, sponsors?: ISponsors, co?: boolean) => {
  const [anglers, setAnglers] = useState<IBasstrakkAngler[]>([]);

  useEffect(() => {
    /**
     * Set state for tournament anglers when api returns.
     * NOTE: *returns a function to capture scope*
     */
    const storeAnglers = () => (response: IBasstrakkAngler[]) => {
      if (response) {
        setAnglers(sponsors ? sponsorRows(response, sponsors) : response);
      }
    };

    const {
      bass_leaderboard: {
        daydate = '',
        new_url: newBaseUrl = '',
      } = {},
    } = bassConfig;
    const uri = `${newBaseUrl}/tournament/basstrakk/leaderboard?tournament_id=${tid}&daydate=${daydate}&CompetitorClass=${co ? '0' : '1'}`;

    const fetchAnglers = async () => {
      await api.subscribe({
        callback: storeAnglers(),
        rate: ANGLER_FETCH_RATE,
        uri,
      });
    };
    fetchAnglers();
  }, [tid, sponsors, co]);

  return anglers;
};

export default useTournamentAnglers;
